import React from 'react'
import { ThemeProvider } from '@emotion/react'
import { Section } from 'component-library/__styling/settings/sections'

interface Props {
    section: Section
    children?: React.ReactNode
}

/**
 * Adds data resolved from the the routing to our theme provider
 */
export const OverrideThemeSection: React.FC<Props> = props => {
    const { children, section } = props
    return <ThemeProvider theme={{ section }}>{children}</ThemeProvider>
}
